<template>
  <div class="three-dots-loader">
    <span class="dot" />
    <span class="dot" />
    <span class="dot" />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from '@vue/composition-api';

export default defineComponent({
    name: 'ThreeDotsLoader',
    setup() {
        // No special logic is required here; purely presentational.
        // You could add props for sizing, color, etc. if needed.
        return {};
    },
});
</script>

<style scoped>
.three-dots-loader {
    display: flex;
    align-items: center;
    justify-content: center;
}

.dot {
    width: 4px;
    height: 4px;
    margin: 0 4px;
    border-radius: 50%;
    background-color: var(--v-secondaryText-base);
    animation: dotPulse 1.2s infinite ease-in-out;
}

/* Delay each dot so they "grow" in sequence */
.dot:nth-child(2) {
    animation-delay: 0.2s;
}
.dot:nth-child(3) {
    animation-delay: 0.4s;
}

@keyframes dotPulse {
    0%,
    80%,
    100% {
        transform: scale(1);
    }
    40% {
        transform: scale(1.6);
    }
}
</style>